import React, {useReducer, useEffect, useContext } from "react";
import activoTypeContext from "./activoTypeContex";
import { getAllActivoTypes, addactivoType, updateActivoType, deleteActivoType } from "../../api/activoType";
import activoTypeReducer from "./activoTypeReducer";

//Types
import { 
    ACTUALIZAR_LIST_ACTIVOTYPE,
  } from "./activoTypeActions";
import authContext from "../authentication/authContex";


const ActivoTypeState = props =>{
     
    const initialState = {
        activoTypeList: null
     };

    const [state, dispatch] = useReducer(activoTypeReducer, initialState);
    const auContext = useContext(authContext);
    const {usuario} = auContext;

    const actualizaractivoTypeList = async () => {
        try{
            const resp = await getAllActivoTypes();
            const activoType = resp.data.data;

            dispatch({
                type: ACTUALIZAR_LIST_ACTIVOTYPE,
                payload: activoType
            });
            
            return activoType;
        }catch(err){
            console.log(err)
        }

    };
    

    const agregarActivoType = async (dato) => {

        try{
            // Luego, puedes enviar estos datos al backend usando una función llamada addactivoType
            const resp = await addactivoType(dato);
            const activoType = resp.data.data;

            return activoType;

        }catch(err){
            console.log(err);
            return null;
        }
        
    };

    const modificarActivoType = async (dato) => {
        try{
            
            const resp = await updateActivoType(dato);
            const activo = resp.data.data;
            
            return activo;
        }catch(err){
            console.log(err)
        }
    }

    const eliminarActivoType = async (id) => {
        try{
            const resp = await deleteActivoType(id);
            const activo = resp.data.data;
            return activo;
        }catch(err){
            console.log(err)
        }
    }

    useEffect(() => {
        if(usuario != null) actualizaractivoTypeList();
    },[usuario])

    return(
        <activoTypeContext.Provider
            value={{
                activoTypeList: state.activoTypeList,
                actualizaractivoTypeList,
                agregarActivoType,
                modificarActivoType,
                eliminarActivoType,
            }}
        >
            {props.children}
        </activoTypeContext.Provider>
    )

}

export default ActivoTypeState;